import { TopPicksMediaPage } from './TopPicksMediaPage'

export function TopPicksSeriesPage() {
  return <TopPicksMediaPage mediaType="series" />
}
